<script lang="ts" setup>
import type { HTMLAttributes } from 'vue'

interface Props {
  class?: HTMLAttributes['class']
  detectScroll?: boolean
  height?: string
}

const props = withDefaults(defineProps<Props>(), {
  detectScroll: true,
  height: '75px',
})

const { cmerge } = useCvtHelpers()
const uistore = useUiStore()
const { y: windowY } = useWindowScroll()

watch(windowY, () => {
  uistore.setScrolled(windowY.value > 0)
})
</script>

<template>
  <div
    :class="cmerge(
      props.class,
    )"
  >
    <nav
      aria-label="Global Navigation"
      class="flex flex-col"
    >
      <div class="flex">
        <!-- Mobile Nav -->
        <div
          v-if="$slots.mobileNav"
          class="flex flex-1 xl:hidden transitions-normal"
        >
          <slot
            name="mobileNav"
            :scrolled="uistore.scrolled"
          />
        </div>

        <!-- Desktop Nav -->
        <div
          v-if="$slots.mainNav"
          class="hidden xl:flex flex-1 gap-x-8 transitions-normal w-full"
        >
          <slot
            name="mainNav"
            :scrolled="uistore.scrolled"
          />
        </div>
      </div>
    </nav>
  </div>
</template>
